import React from 'react';


const BoldTitle = ({boldTitle}) => (
  <h6 className="m-5 font-semibold">{boldTitle}</h6>
);

export default BoldTitle;
